import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './card';

const FeedbackPlaceholder = ({ 
  title = "User Feedback",
  totalFeedback = "0",
  positiveFeedback = "0",
  negativeFeedback = "0"
}) => {
  // Calculate unclassified feedback
  const total = parseInt(totalFeedback) || 0;
  const positive = parseInt(positiveFeedback) || 0;
  const negative = parseInt(negativeFeedback) || 0;
  const unclassified = Math.max(0, total - positive - negative);

  return (
    <Card className="p-6">
      <CardHeader className="p-0 mb-4">
        <CardTitle className="text-lg font-semibold">{title}</CardTitle>
      </CardHeader>
      <CardContent className="p-0 space-y-4">
        {/* Total Feedback */}
        <div className="flex items-center space-x-3">
          <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
          <span className="text-sm text-gray-600">Total Feedback: </span>
          <span className="text-sm font-medium">{totalFeedback}</span>
        </div>
        
        {/* Positive Feedback */}
        <div className="flex items-center space-x-3">
          <div className="w-3 h-3 bg-green-500 rounded-full"></div>
          <span className="text-sm text-gray-600">Positive: </span>
          <span className="text-sm font-medium">{positiveFeedback}</span>
        </div>
        
        {/* Negative Feedback */}
        <div className="flex items-center space-x-3">
          <div className="w-3 h-3 bg-red-500 rounded-full"></div>
          <span className="text-sm text-gray-600">Negative: </span>
          <span className="text-sm font-medium">{negativeFeedback}</span>
        </div>
      </CardContent>
    </Card>
  );
};

export default FeedbackPlaceholder; 